var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"tc-header",style:({ background: _vm.$vuetify.theme.themes.light.primary })},[_c('img',{attrs:{"src":`/LOGO-${_vm.company.name}.png`,"alt":"Logomarca da Empresa"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }